import { CreditCard, ShieldCheck } from 'lucide-react';
import type { User } from '@/types/user.types';
import { ASSINATURA_LABEL, ASSINATURA_CLASS, STATUS_COBRE } from './userDisplay';

interface SubscriptionBadgeProps {
  user: User;
  onManage?: (id: string) => void;
}

// Badge de assinatura, com a mesma prioridade em toda a tela:
// 1) Produtor com assinatura própria → clicável (gerenciar).
// 2) Funcionário coberto pela assinatura do dono → "Coberto · plano".
// 3) Produtor sem assinatura → clicável "Sem assinatura" (conceder).
// 4) Nenhum acesso → traço.
export function SubscriptionBadge({ user, onManage }: SubscriptionBadgeProps) {
  if (user.isProducer && user.assinatura) {
    return (
      <button
        onClick={() => onManage?.(user.id)}
        title="Gerenciar assinatura"
        className={`inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-opacity hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${
          ASSINATURA_CLASS[user.assinatura.status] ?? ASSINATURA_CLASS.none
        }`}
      >
        <CreditCard size={12} className="shrink-0" />
        <span className="truncate">
          {ASSINATURA_LABEL[user.assinatura.status] ?? user.assinatura.status}
          {user.assinatura.plano?.nome ? ` · ${user.assinatura.plano.nome}` : ''}
        </span>
      </button>
    );
  }

  if (user.coberturaHerdada && STATUS_COBRE.has(user.coberturaHerdada.status)) {
    return (
      <span
        title={
          user.coberturaHerdada.produtorNome
            ? `Coberto pela assinatura de ${user.coberturaHerdada.produtorNome}`
            : 'Coberto pela assinatura do produtor'
        }
        className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-info/10 px-2.5 py-1 text-xs font-medium text-info"
      >
        <ShieldCheck size={12} className="shrink-0" />
        <span className="truncate">
          Coberto
          {user.coberturaHerdada.plano?.nome ? ` · ${user.coberturaHerdada.plano.nome}` : ''}
        </span>
      </span>
    );
  }

  if (user.isProducer) {
    return (
      <button
        onClick={() => onManage?.(user.id)}
        title="Gerenciar assinatura"
        className={`inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium transition-opacity hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${ASSINATURA_CLASS.none}`}
      >
        <CreditCard size={12} className="shrink-0" />
        <span className="truncate">Sem assinatura</span>
      </button>
    );
  }

  return <span className="text-sm text-text-hint">—</span>;
}
